export default "__VITE_ASSET__4551ca7c__"